import {OrderLine} from '../transport/apiServiceResponse';

import {toAUD} from './functions';

export const makeByLineText = (item: OrderLine) =>
  item && item.size
    ? item.size.quantity > 1
      ? `${item.size.quantity} x ${item.size.size}${item.size.unit}`
      : `${item.size.size}${item.size.unit}`
    : 'N/A';

export const makeABVText = (product?: OrderLine | null) =>
  product?.alcohol_by_volume_basis_points
    ? `ABV: ${product?.alcohol_by_volume_basis_points / 100}%`
    : '';

/**
 * "was $x.xx"
 */
export const makeOriginalPriceText = (product: OrderLine) =>
  product.sell_price_cents !== product.normal_price_cents
    ? `was ${toAUD(product.normal_price_cents)}`
    : null;
